import React from 'react';
import {Translate} from '../../config/TranslationProvider';

const Description = ({description, eventLinks = [], title = 'description'}) => (
    <div className="atbd_content_module atbd_listing_details">
        <div className="atbd_content_module__tittle_area">
            <div className="atbd_area_title">
                <h2 className="h4">
                    <span className="la la-file-text-o" />&nbsp;<Translate value={title} />
                </h2>
            </div>
        </div>
        <div className="atbdb_content_module_contents" dangerouslySetInnerHTML={{
            __html: description.replace(/href=(["'])/g, 'target="_blank" href=$1'),
        }} />

        {eventLinks.length > 0 && (
            <div className="atbdb_content_module_contents link-listing-wrapper">
                <div className="link-listing-header">
                    Links:
                </div>
                <div className="link-listing">
                    {eventLinks.map(({title, href}) => (
                        <a key={href} href={href} rel="noopener noreferrer" target="_blank">
                            {title ? title.replace(':', '') : href}
                        </a>
                    ))}
                </div>
            </div>
        )}
    </div>
);

export default Description;
